import {useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    Checkbox,
    Fade,
    FormControl,
    Menu,
    MenuItem,
    Radio,
    Select,
    Slider
} from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import BackspaceIcon from '@mui/icons-material/Backspace';
import BoltIcon from '@mui/icons-material/Bolt';
import countriesData from '../../resources/countries.json'
import ctaData from '../../resources/cta.json'
import {ImageOutlined, VideoFileOutlined} from "@mui/icons-material";
import {dateToFormatDateServer, dateToFormatUi} from "../../utils/Utils.jsx";
import {FaFacebook, FaFacebookMessenger, FaInstagram} from "react-icons/fa";
import iconHotmart from "../../assets/icon_hotmart.png";
import iconKiwify from "../../assets/icon_kiwify.png";
import iconVturb from "../../assets/icon_vturb.png";
import iconVidalytics from "../../assets/icon_vidalytics.png";
import iconPandaVideo from "../../assets/icon_pandavideo.png";
import iconAtomicat from "../../assets/icon_atomiccat.png";
import iconShopify from "../../assets/icon_shopify.png";
import iconWordPress from "../../assets/icon_wordpress.png";
import iconClickFunnels from "../../assets/icon_clickfunnels.png";
import iconStripe from "../../assets/icon_stripe.png";
import "./filters.css"
import {API, TOOLTIPS} from "../../utils/Constants";
import {styled} from '@mui/material/styles';
import MuiInput from '@mui/material/Input';
import RequestSvc from "../../services/RequestSvc";
import ctaTypeCombo from './ctaTypeCombo.json';
import {BASE_API_URL} from "../../utils/Constants";

/**
 * Objeto de la clase que se usa para hacer request
 * @type {RequestSvc}
 */
const requestSvc = new RequestSvc();

const Input = styled(MuiInput)`
    width: 42px;
`;

// eslint-disable-next-line react/prop-types
export default function FiltersComponent({setFilterData, setNumberDuplicates}) {
    /*  INIT VARS   */
    /**
     * Contiene los datos de los paises indexados por la descripcion del pais
     */
    let [countryDataOrganizedDescription] = useState([])
    let [ctaDataOrganizedDescription] = useState([])
    let [ctaCombo, setCtaCombo] = useState([])
    let [productCombo, setProductCombo] = useState([])
    /**
     * Contiene los estados de los anuncios organizados por la descripción del estado.
     */
    let [statusIndexedAds] = useState([])
    /**
     * Array que contiene los paises seleccionados
     */
    let [arrayCountries, setArrayCountries] = useState([]);

    let [arrayCta, setArrayCta] = useState([]);
    let [arrayProduct, setArrayProduct] = useState([]);
    /**
     * Contiene las descripciones de las plataformas seleccionadas.
     */
    let [arrayPublisherPlatforms, setArrayPublisherPlatforms] = useState([]);
    /**
     * Contiene los tipos de contenido seleccionado para buscar el anuncio.
     */
    let [arrayContentTypes, setArrayContentTypes] = useState([]);
    /**
     * Contiene el estado seleccionado para la búsqueda del anuncio
     */
    let [estatus, setEstatus] = useState("Todos");
    /**
     * Contiene los códigos de los países seleccionados.
     */
    let [adReachedCountriesCodes, setAdReachedCountriesCodes] = useState([]);
    let [ctaSelected, setCtaSelected] = useState("");
    let [productCodeSelected, setProductCodeSelected] = useState([]);
    /**
     * Contiene el estado del anuncio seleccionado para filtrar la búsqueda.
     */
    let [adActiveStatus, setAdActiveStatus] = useState("ALL");
    /**
     * Contiene el valor de la fecha inicial seleccionada en el calendario.
     */
    const [startDate, setStartDateIn] = useState("");
    /**
     * Contiene el valor de la fecha final seleccionada en el calendario.
     */
    const [endDate, setEndDateIn] = useState(null);
    /**
     * Valores en el campo de búsqueda de texto
     */
    const [searchTermsInput, setSearchTermsInput] = useState("");
    /**
     * Variable necesaria para la configuración del menú que muestra el calendario.
     */
    const [anchorElCalendar, setAnchorElCalendar] = useState(null);

    // ocultar el Slider
    const [isSliderVisible, setIsSliderVisible] = useState(false);

    //input slider
    const [value, setValue] = useState(0);

    // Shared Menu styling for all Select dropdowns in this component
    const commonMenuProps = {
        PaperProps: {
            sx: {
                bgcolor: '#ffffff',
                '& .MuiMenuItem-root': {
                    color: '#000000',
                    fontFamily: 'var(--font-app-family), sans-serif'
                },
                '& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root:hover, & .MuiMenuItem-root.Mui-selected:hover': {
                    bgcolor: '#f3f4f6', // gray-100
                    color: '#000000'
                },
                '& .MuiListItemIcon-root, & .MuiSvgIcon-root': { color: '#000000' },
                '& .MuiListItemText-root, & .MuiTypography-root': { color: '#000000' },
                '& .MuiRadio-root, & .MuiRadio-root.Mui-checked': { color: '#000000' },
                '& *:not(.MuiCheckbox-root):not(.MuiRadio-root):not(.MuiSvgIcon-root)': { color: '#000000' }
            }
        },
        MenuListProps: { sx: { color: '#000000' } }
    };

    /**
     * Bandera que indica si se está mostrando el calendario.
     * @type {boolean}
     */
    const openCalendar = Boolean(anchorElCalendar);
    /**
     * Texto usado como pleceholder del calendario.
     * @type {string}
     */
    const labelCalendar = "Dias Activos";
    /**
     * Contiene el texto actual o mostrado en el botón o ítem del calendario.
     */
    let [showLabelCalendar, setShowLabelCalendar] = useState(labelCalendar);
    /**
     * Contiene el landing seleccionado
     */
    let [landingSelected, setLandingSelected] = useState("");
    /**
     * Contiene el checkout seleccionado
     */
    let [checkoutSelected, setCheckoutSelected] = useState([]);
    /**
     * Contitne el video host seleccionado.
     */
    let [videoHostSelected, setVideoHostSelected] = useState("");
    /**
     * Contiene el constructor seleccionado.
     */
    let [builderSelected, setBuilderSelected] = useState("");
    /**
     * Contiene el nicho seleccionado.
     */
    let [nicheSelected, setNicheSelected] = useState("");
    /**
     * Contiene el tipo de producto seleccionado
     */
    let [productTypeSelected, setProductTypeSelected] = useState("");
    /**
     * Contiene el valor seleccionado o configurado en el slider
     */
    const [valueSlider, setValueSlider] = useState(0);
    /**
     * Configura el rango del slider
     * @type {[{value: number},{value: number}]}
     */
    const sliderMark = [{value: 1}, {value: 40}]
    /**
     * Iconos y descripciones para el combo que muestra las plataformas disponibles
     * para filtrar en la búsqueda de los anuncios.
     * @type {[{name: string, icon: JSX.Element},{name: string, icon: JSX.Element},{name: string, icon: JSX.Element}]}
     */
    const enabledPlatforms = [
        {name: 'Facebook', icon: <FaFacebook/>},
        {name: 'Instagram', icon: <FaInstagram/>},
        {name: 'Messenger', icon: <FaFacebookMessenger/>}
    ]
    /**
     * Iconos y descripciones para el combo que muestra las opciones de creativo o media,
     * que se encuentran disponible para filtrar en la búsqueda de los anuncios.
     * @type {[{name: string, icon: JSX.Element},{name: string, icon: JSX.Element},{name: string, icon: JSX.Element}]}
     */
    const availableContents = [
        {name: 'Video', icon: <VideoFileOutlined/>},
        {name: 'Image', icon: <ImageOutlined/>}
    ]
    /**
     * Contiene la descripción y códigos de estados de los anuncios disponibles para filtrar.
     * @type {[{code: string, name: string},{code: string, name: string},{code: string, name: string}]}
     */
    const availableStatus = [
        {name: 'Activos', code: 'ACTIVE'},
        {name: 'Inactivos', code: 'INACTIVE'},
        {name: 'Todos', code: 'ALL'}
    ]
    /**
     *
     * @type {[{name: string, icon: JSX.Element},{name: string, icon: JSX.Element},{name: string, icon: JSX.Element}]}
     */
    const availableCheckouts = [
        {name: 'Hotmart', icon: <img className={"filters-component-options-icon"} src={iconHotmart}/>},
        {name: 'Kiwify', icon: <img className={"filters-component-options-icon"} src={iconKiwify}/>},
        {name: 'Panda', icon: <img className={"filters-component-options-icon"} src={iconPandaVideo}/>},
        {name: 'ClickFunnels', icon: <img className={"filters-component-options-icon"} src={iconClickFunnels}/>},
        {name: 'Stripe', icon: <img className={"filters-component-options-icon"} src={iconStripe}/>},
        
        
    
    ]

    const availableVideoHost = [
        {name: 'Vturb', icon: <img className={"filters-component-options-icon"} src={iconVturb}/>},
        {name: 'Vidalytics', icon: <img className={"filters-component-options-icon"} src={iconVidalytics}/>},
        {name: 'PandaVideo', icon: <img className={"filters-component-options-icon"} src={iconPandaVideo}/>}
    ]
    const availableBuilder = [
        {name: 'AtomiCat', icon: <img className={"filters-component-options-icon"} src={iconAtomicat}/>},
        {name: 'Shopify', icon: <img className={"filters-component-options-icon"} src={iconShopify}/>},
        {name: 'WordPress', icon: <img className={"filters-component-options-icon"} src={iconWordPress}/>}
    ]
    
    const availableNichos = [
  { name: 'Belleza' },
  { name: 'Dinero' },
  { name: 'Educación' },
  { name: 'Emprendimiento' },
  { name: 'Espiritualidad' },
  { name: 'Finanzas' },
  { name: 'Físicos' },
  { name: 'Gastronomía' },
  { name: 'Inteligencia Artificial' },
  { name: 'Manualidades' },
  { name: 'Otros' },
  { name: 'Relaciones' },
  { name: 'Salud' }
];

    const availableProductTypes = [
        { name: 'todos' },
        { name: 'ebook' },
        { name: 'curso digital' },
        { name: 'otros' }
    ];
    /**
     * Fecha actual
     * @type {Date}
     */
    let enableDateRange = new Date();
    /**
     * Las variables ref se están usando como referencias para saber que div de la grilla de fechas predeterminadas fue seleccionada.
     * Esta implementación se cambiará posteriormente, ya que la implementación original sí necesitaba hacer uso de useRef.
     * Esta implementación no la necesita
     */
    const ref1d = useRef();
    const ref2d = useRef();
    const ref3d = useRef();
    const ref4d = useRef();
    const ref5d = useRef();
    const ref6d = useRef();
    const ref7d = useRef();
    const ref8d = useRef();
    const ref9d = useRef();
    const ref10d = useRef();
    /**
     * Almacena la referencia del item seleccionado en la grilla de fechas predeterminadas.
     */
    const [refSelected, setRefSelected] = useState()
    /**
     * Clase que se asigna al item de la grilla de fechas predeterminadas, cuando no ha sido seleccionada.
     * @type {string}
     */
    let unSelected = "filters-component-calendar-cell-custom-values";
    /**
     * Clase que se asigna al item de la grilla de fechas predeterminadas, cuando ha sido seleccionada.
     * @type {string}
     */
    let selected = "filters-component-calendar-cell-custom-values-selected";

    /*  END VARS    */


    /*  INIT EVENTS */
    /**
     * Evento que se dispara cuando cambia el valor en el campo en el que se ingresa el término de búsqueda.
     * @param event
     * @return {Promise<void>}
     */
    const onChangeInput = async (event) => {
        const inputValue = event.target.value;
        setSearchTermsInput("")
        if (setSearchTermsInput) {
            setSearchTermsInput(inputValue.replace(/^\s+/, ''))
        }
    }
    /**
     * Evento que se dispara cuando se selecciona un pais.
     * @type {boolean}
     */
    const onSelectCountry = (event) => {
        const {target: {value},} = event;
        setArrayCountries(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        // limpiar el array que contiene los codigos seleccionados para evitar repetidos
        setAdReachedCountriesCodes([])
    }
    /**
     * Evento de la seleccion de cta
     * @param event
     * @param key
     */
    const onSelectCta = (event, key) => {
        const {target: {value},} = event;
        let codeSelected = key['key'];
        codeSelected = codeSelected.replace(".$", "")
        setArrayCta(
            typeof value === 'string' ? value.split(',') : value,
        );
        setCtaSelected(codeSelected)
    }
    /**
     *
     * @param event
     */
    const onSelectPlatforms = (event) => {
        const {target: {value},} = event;
        setArrayPublisherPlatforms(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }
    /**
     *
     * @param event
     */
    const onSelectContent = (event) => {
        const {target: {value},} = event;
        setArrayContentTypes(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }
    /**
     * Evento que se dispara cuando se selecciona el estado del anuncio.
     * @param event
     */
    const onSelectStatus = (event) => {
        const {target: {value},} = event;
        setEstatus(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        setAdActiveStatus(statusIndexedAds[value])
    }
    /**
     * Evento necesario para mostrar el calendario.
     * @param event
     */
    const handleClickCalendar = (event) => {
        setAnchorElCalendar(event.currentTarget);
    };
    /**
     * Evento que escucha cuando se hace clic por fuera del calendario cuando se está mostrando.
     * Este evento cierra el calendario. No es un evento obligatorio.
     */
    const handleCloseCalendar = () => {
        setAnchorElCalendar(null);
    };
    /**
     * Evento que se ejecuta cuando se presiona el botón cancelar en el calendario.
     * Este evento configura el backup del formulario.
     */
    const cancelSetCalendar = () => {
        setAnchorElCalendar(null);
    };
    /**
     * Este evento se ejecuta con el botón aplicar del calendario.
     * Configurar las fechas seleccionas por el usuario.
     * @returns {Promise<void>}
     */
    const setDateRange = async () => {
        setAnchorElCalendar(null);
        await setEndDateIn(new Date())
        setShowLabelCalendar(await dateToFormatUi(startDate) + ' - ' + await dateToFormatUi(endDate))
    };
    /**
     * Evento onChange del slider
     * @param event
     * @param newValue
     */
    const handleChangeSlider = (event, newValue) => {
        setValueSlider(newValue);
        setNumberDuplicates(newValue)
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? 0 : Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > 100) {
            setValue(100);
        }
    };

    /**
     *
     * @param e
     */
    const onSelectLanding = (e) => {
        const {target: {value},} = e;
        /*setCheckoutSelected(value);
        setLandingSelected(value);*/
        setCheckoutSelected(
            typeof value === 'string' ? value.split(',') : value
        )
        setLandingSelected(value)
    }
    /**
     *
     * @param e
     */
    const onSelectVideoHost = (e) => {
        const {target: {value},} = e;
        setVideoHostSelected(value);
    }
    /**
     *
     * @param e
     */
    const onSelectBuilder = (e) => {
        const {target: {value},} = e;
        setBuilderSelected(value)
    }
    /**
     *
     * @param e
     */
    const onSelectNiche = (e) => {
        const {target: {value},} = e;
        setNicheSelected(value)
    }
    const onSelectProductType = (e) => {
        const {target: {value},} = e;
        setProductTypeSelected(value)
    }
    /**
     * Evento que se dispara cuando se seleccion el producto.
     * @param event
     * @param key
     */

    /**
     *
     * @param ref
     * @returns {(function(): Promise<void>)|*}
     */
    const onSelectCustomDays = (ref) => async () => {
        setRefSelected(ref)
        if (ref === ref1d) {
            setStartDateIn(await getDateLessAnyDays(0))
        }
        if (ref === ref2d) {
            setStartDateIn(await getDateLessAnyDays(1))
        }
        if (ref === ref3d) {
            setStartDateIn(await getDateLessAnyDays(2))
        }
        if (ref === ref4d) {
            setStartDateIn(await getDateLessAnyDays(3))
        }
        if (ref === ref5d) {
            setStartDateIn(await getDateLessAnyDays(4))
        }
        if (ref === ref6d) {
            setStartDateIn(await getDateLessAnyDays(5))
        }
        if (ref === ref7d) {
            setStartDateIn(await getDateLessAnyDays(6))
        }
        if (ref === ref8d) {
            setStartDateIn(await getDateLessAnyDays(7))
        }
        if (ref === ref9d) {
            setStartDateIn(await getDateLessAnyDays(8))
        }
        if (ref === ref10d) {
            setStartDateIn(await getDateLessAnyDays(9))
        }
        setEndDateIn(await new Date())
    }
    /**
     * Evento que se ejecuta cuando se da clic en el botón buscar.
     */
    const handleSearch = async () => {
        arrayCountries.map(desc => {
            if (!adReachedCountriesCodes.includes(countryDataOrganizedDescription[desc])) {
                adReachedCountriesCodes.push(countryDataOrganizedDescription[desc]);
            }
        });
        const params = new URLSearchParams();

        if (searchTermsInput.length > 0) {
            params.append('keywords', searchTermsInput);
        }
        if (landingSelected.length > 0) {
            params.append('landing', landingSelected);
        }
        if (videoHostSelected.length > 0) {
            params.append('videoHost', videoHostSelected);
        }
        if (builderSelected.length > 0) {
            params.append('pageBuilder', builderSelected);
        }
        if (adReachedCountriesCodes.length > 0) {
            params.append('ad_reached_countries', adReachedCountriesCodes.join(','));
        } else {
            params.append('ad_reached_countries', 'ALL');
        }
        if (ctaSelected !== "") {
            params.append('cta', ctaSelected);
        }
        if (productCodeSelected.length > 0) {
            params.append('product', productCodeSelected.join(','));
        }
        if (arrayPublisherPlatforms.length > 0) {
            params.append('publisher_platforms', arrayPublisherPlatforms.join(',').toUpperCase());
        }
        if (adActiveStatus.length > 0) {
            params.append('ad_active_status', adActiveStatus);
        }
        if (arrayContentTypes.length > 0) {
            params.append('media_type', arrayContentTypes.join(',').toUpperCase());
        }
        if (nicheSelected.length > 0) {
            params.append('niche', nicheSelected);
        }
        if (productTypeSelected.length > 0 && productTypeSelected !== 'todos') {
            params.append('product_type', productTypeSelected);
        }
        if (endDate !== null) {
            params.append('updated_date_min', await dateToFormatDateServer(startDate));
            params.append('updated_date_max', await dateToFormatDateServer(endDate));
        }
        params.append('duplicates', value.toString());

        setFilterData(params.toString());
        // console.log("Debug queryString", queryString)
    };

    /**
     * Resetear los filtros
     */
    const resetFilters = () => {
        // Limpiar el campo de termino de busqueda.
        setSearchTermsInput("")
        // Limpiar el campo de plataformas.
        setArrayPublisherPlatforms([])
        // Limpiar el campo de Paises.
        setArrayCountries([])
        setArrayCta([])
        // Limpiar el campo de rango de fechas.
        setStartDateIn(new Date())
        setEndDateIn(null)
        setShowLabelCalendar(labelCalendar)
        // Limpiar el campo de tipo de contenido
        setArrayContentTypes([])
        // Limpiar el campo de tipo de estado
        setEstatus("")
        setAdActiveStatus("")
        setAdReachedCountriesCodes([])
        // setAdReachedctaCodes([])
        setArrayProduct([])
        setLandingSelected("")
        setBuilderSelected("")
        setNicheSelected("")
        setProductTypeSelected("")
        setVideoHostSelected("")
        setCheckoutSelected([])
        setValueSlider(0)
        setCtaSelected("")
    }

    /**
     *
     * @param lessDay Método para restar días a una fecha.
     * @returns {string} formato YYYY-mm-dd
     */
    const getDateLessAnyDays = async (lessDay) => {
        let currentDate = new Date()
        let dateTimeUnix = currentDate.setDate(currentDate.getDate() - lessDay);
        let resultFormat = new Date(dateTimeUnix);
        let year = resultFormat.getFullYear()
        let month = resultFormat.getMonth() + 1
        let monthFormat = month < 10 ? '0' + month : month
        let day = resultFormat.getDate()
        let dayFormat = day < 10 ? '0' + day : day
        return [year, monthFormat, dayFormat].join('-').toString()
    }

    /*  END EVENTS  */


    /*  INIT METHODS - FUNCTIONS    */

    const loadDataCombos = async () => {
        try {
            /*const res = await requestSvc.get(API.LOAD_COMBO + "cta_type");
            if (res.code !== 200) {
                throw new Error(res.message);
            }*/
            setCtaCombo(ctaTypeCombo);
        } catch (error) {
            console.log(error.message);
        }
        try {
            /*const res = await requestSvc.get(API.LOAD_COMBO + "code_belongs");
            if (res.code !== 200) {
                throw new Error(res.message);
            }
            setProductCombo(res.data)*/
        } catch (error) {
            console.log(error.message);
        }
    }

    /*  END METHODS- FUNCTIONS  */
    useEffect(() => {
        countriesData.map(country => {
            countryDataOrganizedDescription[country.name] = country.value;
        })
        /*ctaData.map(cta => {
            ctaDataOrganizedDescription[cta.COMBO] = cta.ORIGINAL;
        })*/

        availableStatus.forEach(status => {
            statusIndexedAds[status.name] = status.code;
        })
        adReachedCountriesCodes.push("ALL");
    }, []);

    useEffect(() => {
        loadDataCombos()
    }, [])

    return (
        <div className="filters-component-main-layout">
            <div className={"filters-component-container-options"}>
                <div className="filters-component-wrapper-input">
                    <input
                        className="filters-component-search-input"
                        value={searchTermsInput}
                        placeholder="Escribe tu búsqueda"
                        onChange={onChangeInput}/>
                </div>
                {/*<div className="filters-component-wrapper-option">
                    <FormControl className="filters-component-form-control">
                        <Select
                            displayEmpty
                            multiple
                            value={arrayPublisherPlatforms}
                            onChange={onSelectPlatforms}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected.join(', ') || 'Plataformas'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                enabledPlatforms && (
                                    enabledPlatforms.map(platformInfo => {
                                        return (
                                            <MenuItem key={platformInfo.name} value={platformInfo.name}>
                                                <Checkbox
                                                    name={platformInfo.name}
                                                    checked={arrayPublisherPlatforms.includes(platformInfo.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {platformInfo.icon} {platformInfo.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>*/}
                {/* combo de paises OCULTO MIENTRAS PONEMOS PAISES EN LA DB */}
               {/* <div className="filters-component-wrapper-option">
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            value={arrayCountries}
                            onChange={onSelectCountry}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected.join(', ') || 'Paises'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                countriesData && (
                                    countriesData.map(countryInfo => {
                                        return (
                                            <MenuItem key={countryInfo.name} value={countryInfo.name}>
                                                <Radio
                                                    name={countryInfo.name}
                                                    checked={arrayCountries.includes(countryInfo.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    
                                                    {countryInfo.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>*/}
                <div className="filters-component-wrapper-option">
                    <div className={"filters-component-wrapper-option-calendar"}>
                        <div className={"filters-component-wrapper-input-calendar"}
                             onClick={handleClickCalendar}>
                            <input className={"filters-component-input-calendar"} readOnly={true}
                                   value={showLabelCalendar}/>
                        </div>
                        <Menu id="fade-menu"
                              MenuListProps={{
                                  'aria-labelledby': 'fade-button',
                              }}
                              anchorEl={anchorElCalendar}
                              open={openCalendar}
                              onClose={handleCloseCalendar}
                              TransitionComponent={Fade}
                              sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            <div className={"filters-component-calendar-container-custom-values"}>
                                <div className={"filters-component-calendar-row-custom-values"}>
                                    <div className={refSelected === ref1d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref1d)}>{"1D"}</div>
                                    <div className={refSelected === ref2d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref2d)}>{"2D"}</div>
                                    <div className={refSelected === ref3d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref3d)}>{"3D"}</div>
                                    <div className={refSelected === ref4d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref4d)}>{"4D"}</div>
                                    <div className={refSelected === ref5d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref5d)}>{"5D"}</div>
                                </div>
                                <div className={"filters-component-calendar-row-custom-values"}>
                                    <div className={refSelected === ref6d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref6d)}>{"6D"}</div>
                                    <div className={refSelected === ref7d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref7d)}>{"7D"}</div>
                                    <div className={refSelected === ref8d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref8d)}>{"8D"}</div>
                                    <div className={refSelected === ref9d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref9d)}>{"9D"}</div>
                                    <div className={refSelected === ref10d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref10d)}>{"10D"}</div>
                                </div>
                            </div>
                            <div className={"filters-component-wrapper-button"}>
                                <button className={"filters-component-button-outline-border"}
                                        onClick={cancelSetCalendar}>Cancelar
                                </button>
                                <button className={"filters-component-button-regular"}
                                        onClick={setDateRange}>Aplicar
                                </button>
                            </div>
                        </Menu>
                    </div>
                </div>
                <div className="filters-component-wrapper-option">
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            value={arrayContentTypes}
                            onChange={onSelectContent}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected.join(', ') || 'Tipo de contenido'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableContents && (
                                    availableContents.map(contentType => {
                                        return (
                                            <MenuItem key={contentType.name} value={contentType.name}>
                                                <Radio
                                                    name={contentType.name}
                                                    checked={arrayContentTypes.includes(contentType.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {contentType.icon} {contentType.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                {/* <div className="filters-component-wrapper-option" style={{marginLeft: '5px'}}>
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            value={estatus}
                            onChange={onSelectStatus}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected || 'Estado'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableStatus && (
                                    availableStatus.map(statusInfo => {
                                        return (
                                            <MenuItem key={statusInfo.name} value={statusInfo.name}>
                                                <Radio
                                                    name={statusInfo.name}
                                                    checked={estatus.includes(statusInfo.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {statusInfo.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>*/}


                {/* <div className="filters-component-wrapper-option">
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            value={arrayCta}
                            onChange={onSelectCta}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected.join(', ') || 'CTA'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                Object.entries(ctaCombo).map(([code, desc]) => (
                                    <MenuItem key={code} value={desc}>
                                        <Radio
                                            name={desc}
                                            checked={arrayCta.includes(desc)}/>
                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            {desc}
                                        </Box>
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </div>*/}

            </div>
            <div className={"filters-component-container-buttons"}>
                <BoltIcon color={"primary"} sx={{fontSize: '24px'}}/>
                <p style={{fontWeight: "bold", fontSize: "16px", color: "white"}}>Filtros especiales</p>
            </div>
            <div className={"filters-component-container-specials-options"} style={{marginLeft: '5px'}}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    minWidth: "250px",
                    gap: 1,
                    alignItems: "center",
                    
                    marginLeft: '5px',
                    marginRight: '35px',
                }}>
                    <label style={{marginRight: '5px', marginLeft: '5px'}}>&nbsp;#&nbsp;Duplicados</label>
                    <Input
                        value={value || 0}
                        size="small"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        sx={{
                            border: '1px solid #ffffff',
                            borderRadius: '4px',
                            px: 1,
                            height: '24px',
                            width: '60px',
                            color: '#ffffff',
                            '&:before, &:after': { borderBottom: 'none !important' },
                            '& input': { padding: '2px 0' }
                        }}
                        inputProps={{
                            step: 1,
                            min: 0,
                            max: 20,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                    {isSliderVisible && (
                        <Slider
                            aria-label="Slider"
                            value={valueSlider}
                            marks={sliderMark}
                            min={0}
                            max={40}
                            title={TOOLTIPS.TOOLBAR_SLIDER}
                            onChange={handleChangeSlider}
                            sx={{marginLeft: "18px"}}
                        />
                    )}
                </div>
                <div className={"filters-component-wrapper-option"} style={{marginLeft: "-125px"}}>
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            multiple
                            value={checkoutSelected}
                            onChange={onSelectLanding}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected.join(', ') || 'Checkout'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableCheckouts && (
                                    availableCheckouts.map(item => (
                                        <MenuItem value={item.name}>
                                            <Checkbox
                                                name={item.name}
                                                checked={checkoutSelected.includes(item.name)}/>
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                {item.icon} {item.name}
                                            </Box>
                                        </MenuItem>
                                    ))
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <div className="filters-component-wrapper-option">
                    <FormControl className="filters-component-form-control">
                        <Select
                            displayEmpty
                            value={videoHostSelected}
                            onChange={onSelectVideoHost}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected || 'Alojador de video'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableVideoHost && (
                                    availableVideoHost.map(item => {
                                        return (
                                            <MenuItem key={item.name} value={item.name}>
                                                <Radio
                                                    name={item.name}
                                                    checked={videoHostSelected.includes(item.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {item.icon} {item.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <div className="filters-component-wrapper-option">
                    <FormControl className="filters-component-form-control">
                        <Select
                            displayEmpty
                            value={builderSelected}
                            onChange={onSelectBuilder}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected || 'Constructor'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableBuilder && (
                                    availableBuilder.map(item => {
                                        return (
                                            <MenuItem key={item.name} value={item.name}>
                                                <Radio
                                                    name={item.name}
                                                    checked={builderSelected.includes(item.name)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {item.icon} {item.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <div className="filters-component-wrapper-option">
                    <FormControl className="filters-component-form-control">
                        <Select
                            displayEmpty
                            value={nicheSelected}
                            onChange={onSelectNiche}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected || 'Nicho'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableNichos && (
                                    availableNichos.map(item => {
                                        return (
                                            <MenuItem key={item.name} value={item.name}>
                                                <Radio
                                                    name={item.name}
                                                    checked={nicheSelected === item.name}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {item.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <div className="filters-component-wrapper-option">
                    <FormControl className="filters-component-form-control">
                        <Select
                            displayEmpty
                            value={productTypeSelected}
                            onChange={onSelectProductType}
                            variant="outlined"
                            MenuProps={commonMenuProps}
                            renderValue={
                                (selected) => selected || 'Tipo de producto'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                availableProductTypes.map(item => {
                                    return (
                                        <MenuItem key={item.name} value={item.name}>
                                            <Radio
                                                name={item.name}
                                                checked={productTypeSelected === item.name}/>
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                {item.name}
                                            </Box>
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </div>
                {/*<div className="filters-component-wrapper-option">
                    <FormControl className={"filters-component-form-control"}>
                        <Select
                            displayEmpty
                            value={arrayProduct}
                            onChange={onSelectProduct}
                            variant="outlined"
                            renderValue={
                                (selected) => selected.join(', ') || 'Producto'
                            }
                            sx={{height: "100%", "& fieldset": {border: 'none'}}}>
                            {
                                Object.entries(productCombo).map(([code, desc]) => (
                                    <MenuItem key={code} value={desc}>
                                        <Checkbox
                                            name={desc}
                                            checked={arrayProduct.includes(desc)}/>
                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            {desc}
                                        </Box>
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </div>*/}
                <Button
                    disabled={searchTermsInput.length === 0 && landingSelected.length === 0 && videoHostSelected.length === 0 && builderSelected.length === 0 && nicheSelected.length === 0 && productTypeSelected.length === 0 && startDate.length === 0}
                    variant="contained"
                    className="submitBtn"
                    color="primary"
                    onClick={handleSearch}>
                    Buscar
                </Button>
                <BackspaceIcon sx={{fontSize: '24px', marginLeft: "8px"}}
                               onClick={resetFilters}/>
            </div>
        </div>
    );
}